import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

import { SvgDocumentOneListModule } from '../../../../shared/svg/svg-document-one-list/svg-document-one-list.module';
import { Wizard, WizardLoadingType } from '../../../../shared/wizard-v2/wizard-core/wizard/wizard';
import { WizardComponent } from '../../../../shared/wizard-v2/wizard-core/wizard/wizard.component';
import { WizardThreeStepsContainerModule } from '../../../../shared/wizard-v2/wizard-types/wizard-three-steps/components/wizard-three-steps-container/wizard-three-steps-container.module';
import { AccordeonComponent } from '../../../../ui/controls/accordeon/accordeon.component';
import { ReferencesWizardBaseComponent } from '../common/reference-wizard.base';
import { ReferenceFormStep } from '../common/steps/references-form-step';
import { ReferenceResultStep } from '../common/steps/references-result-step';
import { ReferenceGroup } from '../references.entities';

import { ReferenceFirstStep } from './steps/references-first-step';
import { ReferenceSecondStep } from './steps/references-second-step';

@Component({
	selector: 'app-references-group-wizard',
	templateUrl: './references-group-wizard.component.html',
	styleUrls: ['./references-group-wizard.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		AccordeonComponent,
		WizardThreeStepsContainerModule,
		SvgDocumentOneListModule,
	],
})
export class ReferencesGroupWizardComponent extends ReferencesWizardBaseComponent implements WizardComponent, OnChanges {

	@Input()
	public group: ReferenceGroup;


	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.group.firstChange) {
			this.wizard = new Wizard(this.group.name, {
				wizardLoadingType: WizardLoadingType.onStep,
				progressBarHidden: true,
				goBackInvisible: true,
			});

			const step1: ReferenceFirstStep = new ReferenceFirstStep(this, this.wizard);
			const step2: ReferenceSecondStep = new ReferenceSecondStep(this, this.wizard);
			const step3: ReferenceFormStep = new ReferenceFormStep(this, this.wizard);
			const step4: ReferenceResultStep = new ReferenceResultStep(this, this.wizard);

			if (this.group.multilangReference) {
				this.wizard.addStep(step1);
			}

			this.wizard.addStep(step2);
			this.wizard.addStep(step3);
			this.wizard.addStep(step4);

			this.wizard.start();

		}
	}

	public stepBackHandler = () => {
		this.wizard.back();
	}

}
